<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref} from "vue";
import useTools from "@/use/Tools";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";

export default {
    name: "PaySlipView",
    setup() {
        const {loading, dialog} = useSharedData();
        const {$route} = useTools();
        const {getBack} = useSharedMethod();
        
        const paySlip = ref({details: []});
        
        function findById(id) {
            loading.value = true;
            axios.get(`/payments/${id}`).then(response => {
                paySlip.value = response.data;
            }).finally(() => {
                loading.value = false;
            })
        }
        
        onMounted(() => findById($route.params.id));
        
        return {
            loading,
            dialog,
            paySlip,
            getBack
        }
    },
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="900"
        scrollable
    >
        <v-card>
            <w-toolbar color="teal" :title="`${paySlip.workerName} (${paySlip.annexName})`"/>
            <v-card-text>
                <v-container fluid>
                    <pay-slip-component :pay_slip="paySlip"/>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>

</style>